import React, { useEffect } from 'react';
import { assetPathFn } from '../util';
import styles from './HomePageFadeCarouselMobile.module.scss';
import Slider from 'react-slick';
import { Link } from '../root/components/Link';

const settings = {
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  speed: 1500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: false,
};

export const HomePageFadeCarouselMobile: React.FC = () => {
  useEffect(() => {
    ['mobile-top-hero-1_x1440.jpg', 'mobile-top-hero-2_x1440.jpg', 'mobile-top-hero-3_x1440.jpg'].forEach((imageUrl) => {
      const image = new Image();
      image.src = assetPathFn(imageUrl);
    });
  }, []);

  return (
    <div className={styles.fadeCarouselWrapper}>
      <Slider {...settings}>
        <div className={styles.slideWrapper}>
          <Link dataTrackLocation="Homepage Carousel" dataTrackLabel="SuperPower Short: Hero image" href="/products/superpower-short" buttonType="ghost">
            <img className={styles.heroImage} src={assetPathFn('mobile-top-hero-1_x1440.jpg')} alt="step into your power" />
            <div className={styles.heroContentWrapper}>
              <div className={styles.heroText}>
                Step into
                <br /> your power
              </div>
              <div className={styles.heroSubText}>Supercharge your silhouette.</div>
            </div>
          </Link>
          <Link
            size="medium"
            buttonType="transparent"
            text="Shop now"
            dataTrackLocation="Homepage Carousel"
            dataTrackLabel="SuperPower Short: Shop Now"
            href="/products/superpower-short"
          />
        </div>
        <div className={styles.slideWrapper}>
          <Link dataTrackLocation="Homepage Carousel" dataTrackLabel="CrossOver Bra: Hero image" href="/products/crossover-bra" buttonType="ghost">
            <img className={styles.heroImage} src={assetPathFn('mobile-top-hero-3_x1440.jpg')} alt="step into your power" />

            <div className={styles.heroContentWrapper}>
              <div className={styles.heroText}>CrossOver Bra</div>
              <div className={styles.heroSubText}>Once you crossover, you&apos;ll never go back.</div>
            </div>
          </Link>
          <Link
            buttonType="transparent"
            size="medium"
            text="Shop now"
            dataTrackLocation="Homepage Carousel"
            dataTrackLabel="CrossOver Bra: Shop Now"
            href="/products/crossover-bra"
          />
        </div>
        <div className={styles.slideWrapper}>
          <Link dataTrackLocation="Homepage Carousel" dataTrackLabel="Tops: Hero image" href="/collections/tops" buttonType="ghost">
            <img className={styles.heroImage} src={assetPathFn('mobile-top-hero-2_x1440.jpg')} alt="step into your power" />
            <div className={styles.heroContentWrapper}>
              <div className={styles.heroText}>LiftWear Tops</div>
              <div className={styles.heroSubText}>Ditch the bra. Keep the support.</div>
            </div>
          </Link>
          <Link
            buttonType="transparent"
            size="medium"
            text="Shop now"
            dataTrackLocation="Homepage Carousel"
            dataTrackLabel="Tops: Shop Now"
            href="/collections/tops"
          />
        </div>
        <div className={styles.slideWrapper}>
          <Link dataTrackLocation="Homepage Carousel" dataTrackLabel="Legging 2.0: Hero image" href="/products/legging-two" buttonType="ghost">
            <img className={styles.heroImage} src={assetPathFn('mobile-top-hero-4_x1440.jpg')} alt="step into your power" />
            <div className={styles.heroContentWrapper}>
              <div className={styles.heroText}>Legging 2.0</div>
              <div className={styles.heroSubText}>Next level sculpting meets elevated design.</div>
            </div>
          </Link>
          <Link
            size="medium"
            buttonType="transparent"
            text="Shop now"
            dataTrackLocation="Homepage Carousel"
            dataTrackLabel="Legging 2.0: Shop Now"
            href="/products/legging-two"
          />
        </div>
      </Slider>
    </div>
  );
};

export default HomePageFadeCarouselMobile;
